import { cn } from '@/lib/utils';
import { AboutServiceSectionTabEnum } from '@/types/enums';
import H3 from '../ui/H3';

export default function AboutServiceSectionTabButton({
    id,
    label,
    activeTab,
    onTabClick,
}: {
    id: AboutServiceSectionTabEnum;
    activeTab: string;
    label: string;
    onTabClick: () => void;
}) {
    return (
        <button
            key={id}
            type="button"
            className={cn(
                'w-fit relative outline-none mb-6 lg:mb-0 pb-0 lg:pb-7 group lg:translate-y-[2px] overflow-hidden',
            )}
            onClick={onTabClick}
            id={id}
        >
            <H3
                className={cn(
                    'max-lg:text-h4 font-medium hover:text-brand transition-all ease-in-out duration-300',
                    activeTab === id && 'text-brand',
                )}
            >
                {label}
            </H3>
            <span
                className={cn(
                    'absolute bottom-0 left-full h-[2px] bg-brand w-full transform transition-transform duration-500 ease-in-out',
                    activeTab === id
                        ? '-translate-x-full duration-0'
                        : 'translate-x-0 group-hover:-left-full group-hover:translate-x-full',
                )}
            />
        </button>
    );
}
